export enum PurchaseOrderStatusEnum {
  ALL = 'ALL',
  CREATE = 'CREATE', // It seems it is technical (Not exists on the BE)
  EXPIRED = 'EXPIRED', // It seems it is technical (Not exists on the BE)

  GENERATED = 'GENERATED',
  AMENDED = 'AMENDED',
  REFUSED_BY_SUPPLIER = 'REFUSED_BY_SUPPLIER',
  CANCELLED = 'CANCELLED',
  VALIDATED = 'VALIDATED',
}
